






import Vue from "vue";
export default Vue.extend({
  props: ["items"],
  setup() {
    return {};
  },
});
